import React, { useRef } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { get_generic } from "../../../services/http_operations";
import { ReplaceUnderscores } from "../../../services/misc_functions";
import {
  convertArrayOfObjectsToCSV,
  convertArrayOfObjectsToPDF,
  convertArrayOfSheetsToXLSX,
} from "../../../services/objects_manipulation";
import { calculateAggregatedKPI } from "../../../services/operation_tool_services";
import { saveAs } from "file-saver";
export default function DownloadKPIsPage() {
  //state definitions

  const downloadFormatRef = useRef(null);
  const downloadAggregatedFormatRef = useRef(null);

  const handleDownload = async (type) => {
    if (downloadFormatRef.current.value === "Select Format") return;
    //get all measurements, all features, all devices
    const measurementsRes = await get_generic("measurements", {
      limit: -1,
    });
    const measurements = measurementsRes.docs;
    const featureRes = await get_generic("features", {
      limit: -1,
    });
    const features = featureRes.docs;
    /* const deviceRes = await get_generic("devices", {
      limit: -1,
    });*/

    const mergedResponse = measurements
      .filter((m) => !m.feature.includes("_description"))
      .map((m) => {
        const _feature = features.find((f) => f._id === m.feature);
        const _kpiID = m.feature.split("_")[1];
        const descKpi = measurements.find(
          (d) => d.feature === m.feature + "_description"
        );
        const finalKpi = m.samples[0].values.map((v, i) => {
          return {
            Enabler: m.thing,
            Group: ReplaceUnderscores(m.device),
            "Tech RQ": _feature.description,
            "Tech Kpi": ReplaceUnderscores(_feature.items[i].name),
            "Tech Logging Reqs": _feature.items[0].description,
            "Kpi Index": _kpiID,
            "Kpi Value": m.samples[0].values[i],
            "Kpi User Description": descKpi.samples[0].values[i],
          };
        });
        return finalKpi;
      })
      .reverse()
      .flat();

    if (mergedResponse.length === 0) return alert("No KPIs to download");
    if (type === "CSV") {
      const csv = convertArrayOfObjectsToCSV(mergedResponse);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
      saveAs(blob, "KPIs.csv");
    } else if (type === "JSON") {
      const blob = new Blob([JSON.stringify(mergedResponse, null, 4)], {
        type: "application/json",
      });
      saveAs(blob, "KPIs.json");
    } else if (type === "PDF") {
      const doc = convertArrayOfObjectsToPDF(mergedResponse);
      doc.save("KPIs.pdf");
    } else if (type === "XLSX") {
      //divide mergedResponse into sheets, based on groups
      const sheetNames = [...new Set(mergedResponse.map((r) => r.Group))];
      const sheets = sheetNames.map((s) => {
        return {
          name: ReplaceUnderscores(s).slice(0, 30),
          data: mergedResponse.filter((r) => r.Group === s),
        };
      });
      const xlsxBlob = convertArrayOfSheetsToXLSX(sheets);
      saveAs(xlsxBlob, "KPIs.xlsx");
    } else return;
  };

  const handleAggregatedDownload = async (type) => {
    if (downloadAggregatedFormatRef.current.value === "Select Format") return;
    //get all measurements, all features, all devices

    //number of fixed point digits for aggregated values
    const nFixed = 2;

    const mergedResponse = [];
    const featuresRes = await get_generic("features", {
      limit: -1,
    });

    const devicesRes = await get_generic("devices", {
      limit: -1,
    });
    const _features = featuresRes.docs;
    const _devices = devicesRes.docs;

    const _deviceNames = _devices.map((d) => d._id).reverse();

    for (let dev of _deviceNames) {
      const measurementsRes = await get_generic("measurements", {
        limit: -1,
        filter: JSON.stringify({ device: dev }),
      });

      const deviceFeatures = _features.filter(
        (f) =>
          _devices.find((d) => d._id === dev).features.includes(f._id) &&
          !f._id.includes("_description")
      );
      const aggregated = calculateAggregatedKPI(
        measurementsRes.docs,
        _devices,
        dev,
        deviceFeatures
      );

      aggregated.forEach((a) => {
        const _rows = a.maxs.map((v, i) => {
          return {
            Group: ReplaceUnderscores(a.device),
            "Tech RQ": a.techRQs,
            "Tech Kpi": ReplaceUnderscores(a.techKpi[i]),
            "Tech Logging Reqs": a.techLoggingReqs[i],
            "Kpi Index": a.kpiIndex,

            "KPI max value": a.maxs[i].toFixed(nFixed),
            "KPI min value": a.mins[i].toFixed(nFixed),
            // "KPI mean value": a.means[i].toFixed(nFixed),
            // "KPI std dev": a.stds[i].toFixed(nFixed),
          };
        });
        mergedResponse.push(..._rows);
      });
    }
    if (mergedResponse.length === 0)
      return alert("No aggregated KPIs to download");
    if (type === "CSV") {
      const csv = convertArrayOfObjectsToCSV(mergedResponse);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
      saveAs(blob, "Aggregated KPIs.csv");
    } else if (type === "JSON") {
      const blob = new Blob([JSON.stringify(mergedResponse, null, 4)], {
        type: "application/json",
      });
      saveAs(blob, "Aggregated KPIs.json");
    } else if (type === "PDF") {
      const doc = convertArrayOfObjectsToPDF(mergedResponse);
      doc.save("Aggregated KPIs.pdf");
    } else if (type === "XLSX") {
      //divide mergedResponse into sheets, based on groups
      const sheetNames = [...new Set(mergedResponse.map((r) => r.Group))];
      const sheets = sheetNames.map((s) => {
        return {
          name: ReplaceUnderscores(s).slice(0, 30),
          data: mergedResponse.filter((r) => r.Group === s),
        };
      });
      const xlsxBlob = convertArrayOfSheetsToXLSX(sheets);
      saveAs(xlsxBlob, "Aggregated KPIs.xlsx");
    } else return;
  };

  return (
    <div className="page">
      <header className="page-header">Download KPIs</header>
      <main className="page-content">
        <Container fluid>
          <Row style={{ paddingBottom: 5 + "px" }}>
            <Col sm={12}>Download all KPIs</Col>
          </Row>
          <Row style={{ paddingBottom: 5 + "px" }}>
            <Col sm={3}>
              <Form.Select ref={downloadFormatRef}>
                <option>Select Format</option>
                <option>CSV</option>
                <option>JSON</option>
                <option>PDF</option>
                <option>XLSX</option>
              </Form.Select>
            </Col>
          </Row>
          <Row style={{ paddingBottom: 5 + "px" }}>
            <Col sm={3}>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleDownload(downloadFormatRef.current.value);
                }}
              >
                Download
              </Button>
            </Col>
          </Row>
        </Container>

        <hr />
        <Container fluid>
          <Row style={{ paddingBottom: 5 + "px" }}>
            <Col sm={12}>Download all aggregated KPIs</Col>
          </Row>
          <Row style={{ paddingBottom: 5 + "px" }}>
            <Col sm={3}>
              <Form.Select ref={downloadAggregatedFormatRef}>
                <option>Select Format</option>
                <option>CSV</option>
                <option>JSON</option>
                <option>PDF</option>
                <option>XLSX</option>
              </Form.Select>
            </Col>
          </Row>
          <Row style={{ paddingBottom: 5 + "px" }}>
            <Col sm={3}>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleAggregatedDownload(
                    downloadAggregatedFormatRef.current.value
                  );
                }}
              >
                Download
              </Button>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}
